<template lang="pug">
  section#Dos
    //-
      02. Design & User Experience
    SectionTitle(color="#F2E059" seo="02. Design & UI/UX")
      span(slot="number") 2
      span(slot="text1") Design
      span(slot="text2") USER EXPERIENCE

    blockquote.slogan(v-in-viewport.once="true") Bridging the gap between design and code
    blockquote(v-in-viewport.once="true") I enjoy coding fresh <strong>web components</strong> following the look and feel of the original designs, minding carefully about <strong>UX/UI design</strong> of each project.
      |  I do transform the original idea from the graphic design software to the final <strong>user interface</strong> on the web browser.

    Techdesign

</template>

<script>
  import Techdesign from '@/components/Techdesign'

  export default {
    components: {
      Techdesign
    }
  }
</script>

<style lang="sass" scoped>
  #Dos

    blockquote
      color: #efefef
      text-align: left
      line-height: 1.3
      font-weight: 200
      font-size: calc(1.25rem + (3 - 2) * (100vw - 32rem)/ (76.8 - 32))
      margin: calc(2.5rem + (6 - 4) * (100vw - 32rem)/ (76.8 - 32)) 0
      opacity: 0

      &.in-viewport
        animation: .550s fadeIn 1250ms both

      &.slogan
        color: #fff
        font-size: calc(1.5rem + (3 - 2) * (100vw - 32rem)/ (76.8 - 32))
        font-weight: bold
        margin-top: calc(1.5rem + (6 - 4) * (100vw - 32rem)/ (76.8 - 32))
        margin-bottom: -1em
        // &:last-child
        //   margin-bottom: calc(1.5rem + (6 - 4) * (100vw - 32rem)/ (76.8 - 32))
        &.in-viewport
          animation: 1.25s fadeInUp2 550ms both

      > strong
        color: #fff
        font-weight: 600
</style>






// WEBPACK FOOTER //
// src/components/sections/Section02.vue